import React, { useState } from 'react';
import { ScrollLink } from './ScrollLink';
import '../styles/Footer.css';

function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Aqui você pode implementar a lógica para inscrição na newsletter

    setEmail('');
    // Adicionar notificação de sucesso aqui
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <div className="footer-logo">ABRALIBER</div>
            <p className="footer-description">
              Transformando vidas através da educação gratuita e de qualidade. 
              Oferecemos cursos online certificados para impulsionar sua carreira 
              e desenvolvimento pessoal.
            </p>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/share/14akfQLF8m5/"
                className="social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/abraliber"
                className="social-link"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div className="footer-section">
            <h3>Links Rápidos</h3>
            <ul className="footer-links">
              <li><ScrollLink to="/">Início</ScrollLink></li>
              <li><ScrollLink to="/cursos">Cursos</ScrollLink></li>
              <li><ScrollLink to="/sobre-a-abraliber">Sobre Nós</ScrollLink></li>
              <li><ScrollLink to="/certificados">Certificados</ScrollLink></li>
              <li><ScrollLink to="/contato">Contato</ScrollLink></li>
            </ul>
          </div>

          {/* Suporte */}
          <div className="footer-section">
            <h3>Suporte</h3>
            <ul className="footer-links">
              <li><ScrollLink to="/ajuda">Central de Ajuda</ScrollLink></li>
              <li><ScrollLink to="/perguntas-frequentes">FAQ</ScrollLink></li>
              <li><ScrollLink to="/politica-de-privacidade">Política de Privacidade</ScrollLink></li>
              <li><ScrollLink to="/termos-de-uso">Termos de Uso</ScrollLink></li>
              <li><ScrollLink to="/acessibilidade">Acessibilidade</ScrollLink></li>
            </ul>
          </div>

          {/* Contato */}
          <div className="footer-section">
            <h3>Fale Conosco</h3>
            <div className="footer-contact-item">
              <svg className="footer-contact-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              <div>
                <p>(61) 99623-0013</p>
                <p>Seg-Sex: 8h às 18h</p>
              </div>
            </div>
            <div className="footer-contact-item">
              <svg className="footer-contact-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              <p>contato@abraliber.com.br</p>
            </div>
          </div>

          {/* Newsletter */}
          <div className="footer-section footer-newsletter">
            <h3>Newsletter</h3>
            <p className="footer-description">
              Receba as novidades sobre cursos e promoções diretamente no seu e-mail.
            </p>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                placeholder="Seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="newsletter-input"
                required
              />
              <button type="submit" className="newsletter-button">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="22" y1="2" x2="11" y2="13"></line>
                  <polygon points="22,2 15,22 11,13 2,9 22,2"></polygon>
                </svg>
              </button>
            </form>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              &copy; {currentYear} ABRALIBER. Todos os direitos reservados.
            </p>
            <p className="footer-company-id">
              ABRALIBER - CNPJ 65.983.758/0001-32
            </p>
            <div className="footer-bottom-links">
              <ScrollLink to="/politica-de-privacidade">Política de Privacidade</ScrollLink>
              <ScrollLink to="/termos-de-uso">Termos de Uso</ScrollLink>
              <ScrollLink to="/politica-de-privacidade">Cookies</ScrollLink>
            </div>
          </div>
          <div className="footer-made-with">
            Feito com <span className="footer-heart">❤️</span> para transformar vidas através da educação
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
